var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ab-date",class:[
    _vm.icon ? 'ab-date--icon ab-date--icon-readonly' : '',
    _vm.error ? 'has-error' : '',
    !_vm.error ? 'is-valid' : '',
    _vm.error && _vm.errorMessage ? 'has-message' : ''
  ]},[_c('v-date-picker',{attrs:{"mode":_vm.mode,"is-light":"","locale":"nl","popover":{ placement: _vm.$screens({ default: _vm.placement }) }},model:{value:(_vm.dateValue),callback:function ($$v) {_vm.dateValue=$$v},expression:"dateValue"}}),_c('label',[_vm._v(_vm._s(_vm.label)+" "),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }